import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy ``/workspace/integrations/$capability`` per-capability page
 * — redirected to the new fullscreen URL ``/integrations/$capability``.
 * See the parent ``route.tsx`` for the migration rationale.
 */
export const Route = createFileRoute("/_authed/workspace/integrations/$capability")({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/integrations/$capability",
      params: { capability: params.capability },
      search: search as Record<string, unknown>,
      replace: true,
    });
  },
});
